<div class="m-form">
  <div class="m-form__section m-form__section--first">
    <div class="form-group m-form__group m--margin-top-0">
      <div [ngClass]="{'is--loading': isLoading}">
        <div class="ui-select-container dropdown" [ngClass]="{'open': item.length > 1 && focused}">

          <input autocomplete="false" class="form-control ui-select-search" (keyup)="typed($event)" [(ngModel)]="item" (focusin)="showOpen()" (focusout)="clear()" type="text" [placeholder]="'bank-search.searchBank' | transloco">

          <a (click)="removed()" *ngIf="!isLoading && item.length > 1" class="is--remove">
            <i class="la la-remove"></i>
          </a>

          <ul class="ui-select-choices dropdown-menu" role="menu" style="width: 100%;" *ngIf="!isLoading && !selectedItem">
            <ng-container *ngIf="items.length">
              <li role="menuitem" *ngFor="let item of items">
                <div class="ui-select-choices-row">
                  <a class="dropdown-item" (click)="selectItem(item)">
                    <div>{{ item.text }}</div>
                  </a>
                </div>
              </li>
            </ng-container>
            <!-- not found or empty -->
            <ng-container *ngIf="!items.length">
              <li role="menuitem">
                <div class="ui-select-choices-row">
                  <a class="dropdown-item">
                    <div>{{ 'bank-search.noFind' | transloco }}</div>
                  </a>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
